import { gql, useLazyQuery } from '@apollo/client';
import { GetDashboardByIdInput, Query } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

interface GetDashboardVersionParams {
  id?: string;
}

const GET_DASHBOARD_BY_ID = gql`
  query getDashboardByID($id: ID!, $tenantID: ID!, $userID: ID!) {
    getDashboardByID(
      request: { id: $id, tenantID: $tenantID, userID: $userID }
    ) {
      dashboard {
        version
      }
    }
  }
`;

export const useFetchDashboardVersion = () => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const [getVersion] = useLazyQuery<Query, GetDashboardByIdInput>(
    GET_DASHBOARD_BY_ID,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    },
  );

  const getDashboardVersion = useCallback(
    async ({ id }: GetDashboardVersionParams) => {
      if (!id) {
        return;
      }

      const resp = await getVersion({
        variables: {
          id: id ?? '',
          tenantID,
          userID,
        },
      });

      return resp?.data?.getDashboardByID?.dashboard.version;
    },
    [getVersion, tenantID, userID],
  );

  return {
    getVersion: getDashboardVersion,
  };
};
